<template>
  <el-table-column prop="pin" label="PIN" header-align="center" width="160">
    <template #default="scope">
      <div class="flex flex-row items-center relative">
        <div class="flex flex-col w-full">
          <div class="w-full">
            <div class="flex items-center">
              <div
                class="truncate flex-grow"
                :class="{
                  'cursor-pointer': !tableStore.showButtons && scope.row.pin,
                }"
                :title="scope.row.pin"
                @click="
                  !tableStore.showButtons &&
                    scope.row.pin &&
                    handlePinCopy(scope.$index, scope.row.pin)
                "
              >
                <div v-if="!scope.row.pin" class="text-center">
                  <el-text type="danger">---</el-text>
                </div>
                <template v-else>{{ scope.row.pin }}</template>
              </div>
              <Icon
                v-if="scope.row.pin"
                icon="material-symbols:search"
                :inline="true"
                @click="handlePinClick(scope.row)"
                class="text-2xl ml-1 border-2 border-yellow-700 hover:bg-blue-500 cursor-pointer transition-all duration-300 flex-shrink-0 min-w-[24px]"
              />
            </div>
            <Transition
              enter-active-class="transition duration-200 ease-out"
              enter-from-class="transform opacity-0"
              enter-to-class="transform opacity-100"
              leave-active-class="transition duration-500 ease-in"
              leave-from-class="transform opacity-100"
              leave-to-class="transform opacity-0"
            >
              <div
                v-if="pinCopied[scope.$index] || pinError[scope.$index]"
                class="absolute inset-0 flex items-center justify-center bg-gray-800/75 rounded"
              >
                <el-text
                  type="success"
                  size="small"
                  v-if="pinCopied[scope.$index]"
                  ><div class="truncate text-white">
                    Copied to clipboard
                  </div></el-text
                >
                <el-text
                  type="warning"
                  size="small"
                  v-if="pinError[scope.$index]"
                  ><div class="truncate text-white">
                    Error copying - Try a different browser
                  </div></el-text
                >
              </div>
            </Transition>
            <div
              v-if="tableStore.showButtons && scope.row.pin"
              class="text-xs text-gray-500"
            >
              <div class="flex mt-2 justify-center w-full">
                <div
                  class="p-2 text-gray-300 bg-slate-950 hover:bg-slate-900 cursor-pointer text-center max-w-[100px]"
                  @click="handlePinCopy(scope.$index, scope.row.pin)"
                >
                  Copy PIN
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </el-table-column>
</template>

<script setup>
import { Icon } from "@iconify/vue";
import { ref, computed } from "vue";
import { openLink, copyToClipboard } from "@/utils";
import { useTable } from "@/stores";

const tableStore = useTable();

const pinCopied = ref({});
const pinError = ref({});

const handlePinClick = (row) => {
  const cleanPin = row.pin.replace(/-|\s/g, "");
  openLink(`https://www.cookcountyassessor.com/pin/${cleanPin}`);
};

const handlePinCopy = async (index, pin) => {
  try {
    pinError.value[index] = false;
    await copyToClipboard(pin);
    pinCopied.value[index] = true;
    setTimeout(() => {
      pinCopied.value[index] = false;
    }, 2000);
  } catch (e) {
    pinError.value[index] = true;
    setTimeout(() => {
      pinError.value[index] = false;
    }, 2000);
  }
};
</script>
